import React, { useState } from 'react';
import { signIn } from '../../../core/firebase/auth_service';

export default function Step2Password({ data, onBack, onSuccess }) {
  const [password, setPassword] = useState('');
  const [show,     setShow]     = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleLogin = async () => {
    if (password.length < 6) { setError('Mot de passe trop court.'); return; }
    setLoading(true);
    setError('');
    try {
      await signIn({ email: data.email, password });
      onSuccess();
    } catch (e) {
      if (e.code === 'auth/wrong-password' || e.code === 'auth/invalid-credential') {
        setError('Mot de passe incorrect.');
      } else if (e.code === 'auth/user-not-found') {
        setError('Aucun compte trouvé avec cet email.');
      } else {
        setError('Erreur : ' + e.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <button style={styles.back} onClick={onBack}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={styles.stepLabel}>Connexion (2/2)</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Mot de passe</h2>
        <p style={styles.sub}>{data.email}</p>

        <div style={styles.inputWrapper}>
          <input
            style={styles.input}
            type={show ? 'text' : 'password'}
            placeholder="Votre mot de passe"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            autoFocus
          />
          <button style={styles.eye} onClick={() => setShow(!show)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {show
                ? <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>
                : <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
              }
            </svg>
          </button>
        </div>

        {error && <p style={styles.error}>{error}</p>}

        <button style={styles.forgot}>Mot de passe oublié ?</button>
      </div>

      <div style={styles.bottom}>
        <button
          style={{ ...styles.btnNext, opacity: password.length < 1 || loading ? 0.5 : 1 }}
          onClick={handleLogin}
          disabled={password.length < 1 || loading}
        >
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7ff', display: 'flex', flexDirection: 'column', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px' },
  back: { background: 'none', border: 'none', cursor: 'pointer', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepLabel: { color: '#333', fontSize: 15, fontWeight: 600 },
  content: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 24px 20px' },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 },
  sub: { fontSize: 14, color: '#3d5ef5', marginBottom: 40, fontWeight: 500 },
  inputWrapper: { display: 'flex', alignItems: 'center', width: '100%', maxWidth: 380, height: 54, background: '#fff', border: '1.5px solid #dde0f0', borderRadius: 14, padding: '0 16px', gap: 8 },
  input: { flex: 1, border: 'none', outline: 'none', fontSize: 16, color: '#222', background: 'transparent' },
  eye: { background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  forgot: { background: 'none', border: 'none', color: '#3d5ef5', fontSize: 14, cursor: 'pointer', marginTop: 16 },
  error: { color: '#e74c3c', fontSize: 13, marginTop: 10 },
  bottom: { padding: '0 24px 40px' },
  btnNext: { background: '#3d5ef5', color: '#fff', border: 'none', borderRadius: 14, height: 54, fontSize: 16, fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: 480, display: 'block', margin: '0 auto' },
};
